
export default (data) => data
